<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-material-card
      color="light-blue"
      icon="mdi-account-tie"
      title="Usuarios"
      class="px-5 py-3"
    >
      <v-data-table
        v-if="usuarioslist"
        :headers="headers"
        :items="usuarios"
        :search="search"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer />
            <v-btn
              color="primary"
              fab
              dark
              small
              class="mb-2"
              @click="addUsuarios()"
            >
              <v-icon
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.nombre }}</td>
            <td>{{ item.apellido }}</td>
            <td>{{ item.email }}</td>
            <td>
              <v-icon
                small
                class="mr-2"
                color="success"
                @click="editItem(item)"
              >
                mdi-pencil-outline
              </v-icon>
              <v-icon
                small
                color="error"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <addUsuarios
        :edited-item="datos"
        :edited-index="editedIndex"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import addUsuarios from './addUsuarios.vue'
  export default {
    name: 'UsuariosTable',
    components: {
      addUsuarios,
    },
    data: vm => {
      return {
        search: '',
        snackbar: false,
        colorSnak: 'info',
        text: '',
        timeout: 3000,
        datos: {},
        editedIndex: -1,
        headers: [
          {
            text: 'Nombre',
            align: 'left',
            sortable: true,
            value: 'nombre',
          },
          {
            text: 'Apellido',
            align: 'left',
            sortable: true,
            value: 'apellido',
          },
          {
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'email',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            sortable: false,
          },
        ],
        emailRules: [
          v => !!v || 'EL correo electrónico es requerido',
          v => /.+@.+\..+/.test(v) || 'Ingresa un correo valido',
        ],
      }
    },
    computed: {
      usuarioslist: {
        get () {
          return this.$store.state.usuarios.usuarioslist
        },
      },
      usuarios: {
        get () {
          return this.$store.state.usuarios.usuarios
        },
        set (value) {
          return this.$store.commit('usuarios/setUsuarios', value)
        },
      },
      loading: {
        get () {
          return this.$store.state.usuarios.loading
        },
      },
    },
    mounted () {
      this.$store.dispatch('usuarios/getUsuarios')
    },
    methods: {
      addUsuarios () {
        this.datos = {}
        this.editedIndex = -1
        this.$store.commit('usuarios/setRegister', true)
      },
      editItem (item) {
        this.editedIndex = this.usuarios.indexOf(item)
        this.datos = Object.assign({}, item)
        this.$store.commit('usuarios/setRegister', true)
      },
      deleteItem (item) {
        this.$confirm('Está seguro que desea eliminar el registro?', {
          buttonTrueText: 'Si',
          buttonFalseText: 'No',
        })
          .then(res => {
            if (res) {
              this.$store.dispatch('usuarios/deleteUsuario', item.id)
                .then((response) => {
                  if (response.data.user) {
                    Vue.notify({
                      group: 'loggedIn',
                      text: response.data.success,
                      type: 'teal accent-3',
                      duration: 5000,
                    })
                  } else {
                    Vue.notify({
                      group: 'loggedIn',
                      text: response.data.success,
                      type: 'red accent-2',
                      duration: 5000,
                    })
                  }
                })
                .catch(err => {
                  // eslint-disable-next-line
                  console.log(err)
                  Vue.notify({
                    group: 'loggedIn',
                    text: 'No se pudo eliminar en este momento',
                    type: 'red accent-2',
                    duration: 5000,
                  })
                },
                )
            }
          })
      },
    },

  }
</script>

<style scoped>
.v-card {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
